import { Component } from 'react'
import _ from 'lodash'

class BaseComponent extends Component {
	constructor(props) {
		super(props)
		this.setState = this.setState.bind(this)
	}

	// Thenify setStage https://github.com/facebook/react/issues/2642#issuecomment-274331886
	setState(state, callback = _.noop) {
		return new Promise((resolve, reject) => {
			super.setState(state, () => {
				if (_.isFunction(callback)) {
					return resolve(callback())
				}
				return reject(`${callback} is not a function`)
			})
		})
	}
}

export default BaseComponent



// WEBPACK FOOTER //
// ./src/components/BaseComponent.js